import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'angular-highcharts';
import dayjs from 'dayjs/esm';
import * as cloneDeep from 'lodash/cloneDeep';
import * as moment from 'moment';
import { Moment } from 'moment';
import { combineLatest } from 'rxjs';
import {
  ClickAndNavigationService,
  CommonService,
  EnergyService,
  PlantServiceService,
  SiteService,
  UtilitiesService
} from 'src/app/services/index';
import { Constants, DateService, Highcharts$ } from 'src/app/shared/index';
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
@Component({
  selector: 'app-over-view',
  templateUrl: './over-view.component.html',
  styleUrls: ['./over-view.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'hi-IN'},
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class OverViewComponent implements OnInit, AfterViewInit {
  formData: UntypedFormGroup;
  dateRange: any;
  alwaysShowCalendars: boolean;
  ranges: any = {
    // 'Today': [Moment$(), Moment$()],
    Yesterday: [dayjs().subtract(1, 'days'), dayjs().subtract(1, 'days')],
    'Last 7 Days': [dayjs().subtract(6, 'days'), dayjs()],
    'Last 30 Days': [dayjs().subtract(29, 'days'), dayjs()],
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')]
    // 'Last Month': [Moment$().subtract(1, 'month').startOf('month'), Moment$().subtract(1, 'month').endOf('month')]
  };
  totalEnergyCunsumptionHCChart: Chart;
  totalEnergyCostHCChart: Chart;
  totalEnergyCunsumptionHCChart_Test: Chart;
  totalEnergyCunsumptionHCChart_Test_1: Chart;
  costBreakupHCChart: Chart;
  totalCostBreakupHCChart: Chart;
  costBreakupHCChart_Test: Chart;
  kpiTrendsChart: Chart;
  totalEnergyChartOption: any;
  costBreakupOption: any;
  siteId: string;
  startDateStr: string;
  endDateStr: string;
  startDate = new UntypedFormControl(moment());
  endDate = new UntypedFormControl(moment());
  isFirstLoaded = true;
  isDateChanged = false;
  generatedTimeMsg = '';
  querySiteId: object;
  colors = ['#ffe400', '#26b24a', '#e0697f', '#00406D', '#39c0ff'];
  totalEnergyConsumptionValue = 'NA';
  firstShiftKwhValue = 'NA';
  secondShiftKwhValue = 'NA';
  nightShiftKwhValue = 'NA';
  totalBreakupCost = 'NA';
  firstShiftCost = 'NA';
  secondShiftCost = 'NA';
  nightShiftCost = 'NA';
  utilityConsumptionData = [];
  isPlantNavigationView = false;
  clickAndNavigateFeatureEnabled = false;
  siteDetail: any;
  fullNavigationImageURL: string;
  navigationImageData: any;
  carbonFootPrint = 0;
  processName = 'Whole Plant';
  timeBaseRanges = ['Today', 'Weekly', 'Monthly', 'Yearly'];
  timeBase = 'Daily';
  activeAlerts = 0;
  processes: any;
  yesterdayString: String;
  kpiTrendData: any;
  isNotViewFull = true;
  buttons: any;
  isOnViewFull = false;
  max = new Date();
  startView = 'month';
  minView = 'day';
  hourWiseDataRequired = false;
  isValidStartDate = true;
  startDateErrorMessage: String;
  isValidEndDate = true;
  endDateErrorMessage: String;
  langData: any;
  constructor(
    private energyService: EnergyService,
    private dateService: DateService,
    private plantService: PlantServiceService,
    private clickAndNavigationService: ClickAndNavigationService,
    private siteService: SiteService,
    private commonService: CommonService,
    private utilitiesService: UtilitiesService,
    private fb: UntypedFormBuilder,
    private datePipe: DatePipe,
    private router: Router,
    private activeRoute: ActivatedRoute,
    public translate: TranslateService
  ) {
    this.translate.stream('overview').subscribe((subStream) => {
      this.langData = subStream;
    });
    this.totalEnergyChartOption = this.getTotalEnergyChartOption();
    this.costBreakupOption = this.getCostBreakUpChartOption();
    this.totalEnergyCostHCChart = new Chart(this.totalEnergyChartOption);
    this.totalEnergyCunsumptionHCChart = new Chart(this.totalEnergyChartOption);

    this.totalCostBreakupHCChart = new Chart(this.costBreakupOption);
    this.costBreakupHCChart = new Chart(this.costBreakupOption);
    //
    this.yesterdayString = `Yesterday (${dayjs()
      .subtract(1, 'days')
      .format(Constants.MOMENT_DATE_FORMAT.DAY_FORMAT)})`;
    // Testing
    this.totalEnergyCunsumptionHCChart_Test = new Chart(
      this.totalEnergyChartOption
    );
    this.totalEnergyCunsumptionHCChart_Test_1 = new Chart(
      this.totalEnergyChartOption
    );
    this.costBreakupHCChart = new Chart(this.costBreakupOption);
    // Testing
    this.costBreakupHCChart_Test = new Chart(this.costBreakupOption);
    this.alwaysShowCalendars = true;
    this.dateRange = {
      startDate: '2020-03-01T07:01:39.547Z',
      endDate: '2020-03-15T07:01:39.547Z'
    };
    this.onTimeBaseChange();
  }

  ngOnInit() {
    this.isPlantNavigationView = false;
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
      this.querySiteId = Object.assign({}, { siteId: this.siteId });
      this.transformDate();
      this.getSiteDetailInfo(this.siteId);
      this.processDataAndDrawChart();
      this.fetchUtilityConsumptionData();
      this.getProcessBySite();
    });
  }
  chosenStartDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.year(normalizedYear.year());
    this.startDate.setValue(moment(ctrlValue).startOf('year'));
    // this.startDate.setValue(ctrlValue);
    datepicker.close();
    this.processDataAndDrawChart();
  }
  chosenStartDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
    this.processDataAndDrawChart();
  }
  chosenEndDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.year(normalizedYear.year());
    this.endDate.setValue(moment(ctrlValue).startOf('year'));
    // this.endDate.setValue(ctrlValue);
    datepicker.close();
    this.processDataAndDrawChart();
  }
  chosenEndDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.endDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
    this.processDataAndDrawChart();
  }
  transform(date: UntypedFormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }
  private transformDate = () => {
    this.startDateStr = this.transform(this.startDate);
    this.endDateStr = this.transform(this.endDate);
  };
  onTimeBaseChange(event?: any) {
    if (
      !this.commonService.isNullOrUndefined(event) &&
      !this.commonService.isNullOrUndefined(event.srcElement)
    ) {
      this.timeBase = event.srcElement.value;
    }

    switch (this.timeBase) {
      case 'Yearly': {
        this.startView = 'multi-year';
        this.minView = 'year';
        this.startDate = new UntypedFormControl(moment().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Monthly': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new UntypedFormControl(moment().startOf('month'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Quarterly': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new UntypedFormControl(moment().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Weekly': {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new UntypedFormControl(moment().startOf('week'));
        this.hourWiseDataRequired = false;
        break;
      }
      default: {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new UntypedFormControl(moment().subtract(1, 'days'));
        this.hourWiseDataRequired = true;
        break;
      }
    }
    this.endDate = new UntypedFormControl(moment().subtract(1, 'days'));
    this.validateStartDate();
  }
  getSiteDetailInfo(siteId) {
    this.plantService.getSiteDetail(siteId).subscribe((data) => {
      this.siteDetail = data;
      if (data.attachments !== undefined) {
        this.utilitiesService.displayPlantLayout(this.siteId);
      }
    });
  }
  ngAfterViewInit() {
    const seft = this;
    this.buttons = Highcharts$.getOptions().exporting.buttons;
    Highcharts$.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: this.buttons.contextButton.menuItems.slice(0, 2)
          }
        }
      }
    });
    // document.addEventListener('resize', function () {
    window.onresize = function () {
      const dom = document.getElementById('chartContainer');
      const costWidgetDom = document.getElementById(
        'costBreakupChartContainer'
      );
      if (seft.commonService.isNullOrUndefined(dom)) {
        return;
      }
      if (seft.commonService.isNullOrUndefined(costWidgetDom)) {
        return;
      }
      if (dom && dom.clientHeight > 400) {
        setTimeout(() => {
          dom.setAttribute('height', '400');
        }, 200);
      }
      if (costWidgetDom && costWidgetDom.clientHeight >= 300) {
        seft?.costBreakupHCChart?.ref.setSize(
          costWidgetDom.clientWidth,
          costWidgetDom.clientHeight < 200 ? costWidgetDom.clientHeight : 250
        );
      }
      if (document.fullscreenElement) {
        seft.kpiTrendsChart.ref.setSize(
          document.documentElement.clientWidth,
          document.documentElement.clientHeight
        );
      } else {
        seft?.kpiTrendsChart?.ref.setSize(
          dom.clientWidth,
          dom.clientHeight < 200 ? dom.clientHeight : 250
        );
      }
    };
    document.addEventListener('fullscreenchange', function () {
      seft.isOnViewFull = !seft.isOnViewFull;
      if (seft.kpiTrendsChart.ref) {
        seft.kpiTrendsChart.ref.reflow(new Event('resize'));
        seft.kpiTrendsChart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      if (seft.kpiTrendsChart.ref) {
        seft.kpiTrendsChart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      seft.isNotViewFull = !seft.isNotViewFull;
    });
  }
  datesUpdated(event) {}
  public onChangeDateRange = () => {
    if (
      dayjs(this.dateRange.endDate).diff(
        dayjs(this.dateRange.startDate),
        'days'
      ) > 31
    ) {
      this.commonService.showDialogMessage(
        this.translate.instant(Constants.DATE_LIMIT_31_DAYS)
      );
      return;
    }
    if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
    if (
      this.isFirstLoaded === false &&
      this.commonService.isNullOrUndefined(this.siteId)
    ) {
      this.processDataAndDrawChart();
    }
  };

  /**
   * Method to fetch utility cosumption data for the selected site within a date range
   *
   * @memberof OverViewComponent
   */
  private fetchUtilityConsumptionData = () => {
    this.siteService
      .fetchUtilityConsumptionInfo(
        this.siteId,
        this.startDateStr,
        this.endDateStr
      )
      .subscribe((data) => {
        if (Array.isArray(data)) {
          data.forEach((arrayItem) => {
            if (arrayItem.consumption && arrayItem.consumption !== '-') {
              const tempConsumption = arrayItem.consumption.split(' ');
              const val = tempConsumption[0];
              const unit = ' ' + tempConsumption[1];
              arrayItem['consumptionValue'] = +val;
              arrayItem['consumptionUnit'] = unit;
            }
            if (arrayItem.cost && arrayItem.cost !== '-') {
              const tempCost = arrayItem.cost.split(' ');
              const val = tempCost[0];
              const unit = ' ' + tempCost[1];
              arrayItem['costValue'] = +val;
              arrayItem['costUnit'] = unit;
            }
            const utility = this.langData[arrayItem.misService];
            arrayItem['utility'] = utility;
          });
          this.utilityConsumptionData = data;
        }
      });
  };

  private getProcessBySite() {
    this.siteService.getProcessBySiteId(this.siteId).subscribe((data) => {
      this.processes = data;
    });
  }

  /**
   * Method to get carbon footprint for the selected site nad process within a date range
   *
   * @memberof OverViewComponent
   */
  private GetCo2Footprint = () => {
    const params = {
      siteId: this.siteId,
      processName: this.processName,
      timeBase: this.timeBase,
      startDate: this.startDateStr,
      endDate: this.endDateStr
    };
    this.siteService.getCarbonFootPrint(params).subscribe((data) => {
      if (data) {
        this.carbonFootPrint = data;
      }
      if (data == 0) {
        this.carbonFootPrint = 0;
      }
    });
  };

  /**
   * Method to get KPI Trends for the selected site within a date range
   *
   * @memberof OverViewComponent
   */
  private getKPITrends = () => {
    const opt = this.getProcessEnergyChartOption();
    this.siteService
      .getKPITrendsChart(this.siteId, this.startDateStr, this.endDateStr)
      .subscribe((data) => {
        if (data !== undefined) {
          const result = [];
          const dateArr = [];
          const holdArr = [];
          for (let i = 0; i < data.XAxisArray.length; i++) {
            dateArr.push(data.XAxisArray[i]);
          }

          for (let i = 0; i < data.servicesAndValues.length; i++) {
            let newArr = [];
            for (let j = 0; j < data.servicesAndValues[i].values.length; j++) {
              newArr.push(parseFloat(data.servicesAndValues[i].values[j]));
            }

            holdArr.push({
              name: this.langData[data.servicesAndValues[i].service],
              data: newArr
            });
          }

          for (let j = 0; j < holdArr.length; j++) {
            result.push({
              name: holdArr[j].name,
              data: holdArr[j].data
            });
          }

          opt.xAxis.categories = dateArr;

          opt.series = result;
          this.kpiTrendsChart = new Chart(<any>opt);
        }
      });
  };

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  /**
   * Method to process data and draw chart for the selected site within a date range
   *
   * @memberof OverViewComponent
   */
  private processDataAndDrawChart = () => {
    this.transformDate();

    this.isFirstLoaded = false;
    this.siteService
      .getConsumptionBreakUp(this.siteId, this.startDateStr, this.endDateStr)
      .subscribe((data) => {
        const chartData = [];
        let total = 0;
        if (data.data !== undefined) {
          for (let i = 0; i < data.data.length; i++) {
            total += data.data[i];
            chartData.push([data.categories[i], data.data[i]]);
          }
          if (data.data.length === 3) {
            this.firstShiftKwhValue = data.data[0] + ' Kwh';
            this.secondShiftKwhValue = data.data[1] + ' Kwh';
            this.nightShiftKwhValue = data.data[2] + ' Kwh';
          }
        }

        this.totalEnergyConsumptionValue =
          Highcharts$.numberFormat(
            total,
            Constants.DECIMAL_FORMAT.SOLAR_DECIMAL_NO
          ) + ' Kwh';

        this.totalEnergyChartOption.series[0].data = chartData;
        this.totalEnergyCostHCChart = new Chart(this.totalEnergyChartOption);
        this.totalEnergyCunsumptionHCChart = new Chart(
          this.totalEnergyChartOption
        );
        // Testing
        const optionsTest = cloneDeep(this.totalEnergyChartOption);
        optionsTest.plotOptions.pie.showInLegend = false;
        this.totalEnergyCunsumptionHCChart_Test = new Chart(optionsTest);
        this.totalEnergyCunsumptionHCChart_Test_1 = new Chart(optionsTest);
      });

    this.siteService
      .getCostBreakUp(this.siteId, this.startDateStr, this.endDateStr)
      .subscribe((data) => {
        const chartData = [];
        let total = 0;
        if (data.data !== undefined) {
          for (let i = 0; i < data.data.length; i++) {
            total += data.data[i];
            chartData.push([this.langData[data.categories[i]], data.data[i]]);
          }
          if (data.data.length === 3) {
            this.firstShiftCost = data.data[0] + this.langData.currency;
            this.secondShiftCost = data.data[1] + this.langData.currency;
            this.nightShiftCost = data.data[2] + this.langData.currency;
          }
        }

        this.totalBreakupCost =
          Highcharts$.numberFormat(
            total,
            Constants.DECIMAL_FORMAT.SOLAR_DECIMAL_NO
          ) +
          ' ' +
          this.langData.currency;

        this.costBreakupOption.series[0].data = chartData;
        this.totalCostBreakupHCChart = new Chart(this.costBreakupOption);
        this.costBreakupHCChart = new Chart(this.costBreakupOption);
      });

    this.plantService.getShiftsBySiteId(this.siteId).subscribe((data) => {
      if (data.length > 0) {
        const firstShiftStart = data[0].shiftStart;
        const lastShiftEnd = data[data.length - 1].shiftEnd;
        const dayRange = dayjs(this.endDate.value).diff(
          dayjs(this.startDate.value),
          'days'
        );
        let newDate;
        if (dayRange === 0) {
          newDate = dayjs(this.endDate.value).add(1, 'days');
        } else {
          newDate = dayjs(this.endDate.value);
        }
        this.generatedTimeMsg = `${this.translate.instant(
          Constants.GENERATED_TIME_MSG
        )}
        ${dayjs(this.startDate.value).format(
          Constants.MOMENT_DATE_FORMAT.DAY_FORMAT
        )}
        ${dayjs(firstShiftStart).format(
          Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
        )}
        ${this.translate.instant(Constants.TO)} ${dayjs(newDate).format(
          Constants.MOMENT_DATE_FORMAT.DAY_FORMAT
        )}
        ${dayjs(lastShiftEnd).format(
          Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
        )}`;
      }
    });
    this.GetCo2Footprint();
    this.fetchUtilityConsumptionData();
    this.getKPITrends();
    this.siteService.getActiveAlertsOfSite(this.siteId).subscribe((data) => {
      if (data > 0) {
        this.activeAlerts = data;
      }
    });
  };

  // New REQ
  private getTotalEnergyChartOption = () => {
    const option = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '80%'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      tooltip: {
        formatter: function () {
          return (
            '<b>' +
            this.point.name +
            '</b><br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ': ' +
            Highcharts$.numberFormat(
              this.y,
              Constants.DECIMAL_FORMAT.DECIMAL_NO
            ) +
            ' kWh (' +
            Highcharts$.numberFormat(
              this.percentage,
              Constants.DECIMAL_FORMAT.DECIMAL_NO
            ) +
            '%)'
          );
        }
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -20,
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return (
                Highcharts$.numberFormat(
                  this.point.percentage,
                  Constants.DECIMAL_FORMAT.DECIMAL_NO
                ) + ' %'
              );
              // return Highcharts$.numberFormat(this.y, Constants.DECIMAL_FORMAT.DECIMAL_NO);
            }
          },
          startAngle: -180,
          endAngle: 180,
          // center: ['50%', '75%'],
          size: '100%',
          showInLegend: true
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      // colors: ['#7CB5EC', '#90ED7D', '#7F7F7F'],
      colors: this.colors,
      legend: {
        // layout: 'vertical',
        align: 'center',
        verticalAlign: 'bottom'
        // itemMarginTop: 10,
        // itemMarginBottom: 10
      },
      series: [
        {
          type: 'pie',
          name: 'Energy',
          innerSize: '60%',
          data: []
        }
      ]
    };
    return option;
  };

  /**
   * Method to get cost breakup chart option
   *
   * @memberof OverViewComponent
   */
  private getCostBreakUpChartOption = () => {
    const option = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '100%',
        renderTo: 'container',
        margin: [0, 0, 70, 0],
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      tooltip: {
        formatter: function () {
          return (
            '<b>' +
            this.point.name +
            '<br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ': ' +
            Highcharts$.numberFormat(
              this.y,
              Constants.DECIMAL_FORMAT.ZERO_DECIMAL,
              '.',
              ','
            ) +
            ' JPY' +
            ' (' +
            Highcharts$.numberFormat(
              this.percentage,
              Constants.DECIMAL_FORMAT.ZERO_DECIMAL
            ) +
            '%)</b>'
          );
        }
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -20,
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return (
                Highcharts$.numberFormat(
                  this.point.percentage,
                  Constants.DECIMAL_FORMAT.ZERO_DECIMAL
                ) + ' %'
              );
            }
          },
          startAngle: -180,
          endAngle: 180,
          // center: ['50%', '75%'],
          size: '100%',
          showInLegend: true
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      // colors: ['#7CB5EC', '#90ED7D', '#7F7F7F'],
      colors: this.colors,
      legend: {
        // layout: 'vertical',
        align: 'center',
        verticalAlign: 'bottom',
        // floating: true,
        itemStyle: {
          // fontSize: '10'
        }
        // itemMarginTop: 10,
        // itemMarginBottom: 10
      },
      series: [
        {
          type: 'pie',
          name: this.langData?.utility?.table?.cost,
          innerSize: '60%',
          data: []
        }
      ]
    };
    return option;
  };

  /**
   * Method to get process energy chart option
   *
   * @memberof OverViewComponent
   */
  private getProcessEnergyChartOption = () => {
    const option = {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      colors: this.colors,
      xAxis: {
        categories: [],
        labels: {
          style: {
            fontWeight: 'bold',
            fontSize: 12
          }
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        labels: {
          formatter: function () {
            // if (this.value > 1000000) {
            //   return (
            //     Highcharts$.numberFormat(this.value / 1000000, 0) + 'M JPY'
            //   );
            // } else if (this.value > 1000) {
            //   return Highcharts$.numberFormat(this.value / 1000, 0) + 'K JPY';
            // } else {
            return Highcharts$.numberFormat(this.value, 0, '.', ',') + ' JPY';
            // }
          },
          style: {
            fontWeight: 'bold',
            fontSize: 12
          }
        },
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
            color: 'gray',
            textOutline: '0'
          }
          // formatter: function () {
          // let val;
          // for (let i = 0; i < this.axis.series[0].xData.length; i++) {
          //   val = 0;
          //   for (let j = 0; j < this.axis.series.length; j++) {
          //     val = Highcharts$.numberFormat(
          //       this.axis.series[j].yData[i],
          //       Constants.DECIMAL_FORMAT.DECIMAL_NO
          //     );
          //   }
          //   return val;
          // }
          // let dataSum = 0;
          // const seriesData = this.series.data;
          // for (let i = 0; i < seriesData.length; i++) {
          //   dataSum += seriesData[i].y;
          // }
          // const pcnt = (this.y / dataSum) * 100;
          // return Highcharts$.numberFormat(
          //   pcnt,
          //   Constants.DECIMAL_FORMAT.ZERO_DECIMAL
          // );
          // }
        }
      },
      // legend : {
      //   align : 'center',
      //   verticalAlign : 'bottom',
      //   floating : true,
      //   backgroundColor : 'white',
      //   borderColor : '#CCC',
      //   borderWidth : 1,
      //   shadow : false
      // },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
            color: 'grey',
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return Highcharts$.numberFormat(
                this.y,
                Constants.DECIMAL_FORMAT.ZERO_DECIMAL
              );
            }
          }
        }
      },
      tooltip: {
        formatter: function () {
          let dataSum = 0;
          const seriesData = this.series.data;
          for (let i = 0; i < seriesData.length; i++) {
            dataSum += seriesData[i].y;
          }
          const pcnt = (this.y / dataSum) * 100;

          // eslint-disable-next-line max-len
          return (
            '<b>' +
            this.key +
            '<br/>' +
            Highcharts$.numberFormat(
              pcnt,
              Constants.DECIMAL_FORMAT.ZERO_DECIMAL
            ) +
            ' %<br/>' +
            Highcharts$.numberFormat(
              this.y,
              Constants.DECIMAL_FORMAT.ZERO_DECIMAL,
              '.',
              ','
            ) +
            ' JPY</b>'
          );
        }
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: ''
        }
      ]
    };
    return option;
  };

  /**
   * Method Plant Virtual navigation
   *
   * @memberof OverViewComponent
   */
  public onPlantVirtualNavigationClick = () => {
    // this.isPlantNavigationView = true;
    this.router.navigate(['/site/plant-navigation'], {
      queryParams: { siteId: this.siteId }
    });
  };

  /**
   * Method to navigate to Notifications page and view faults
   *
   * @memberof OverViewComponent
   */
  viewFault() {
    this.router.navigate(['/site/energy-dashboard', 'notifications'], {
      queryParams: { siteId: this.siteId }
    });
  }

  validateStartDate() {
    this.isValidEndDate = true;
    this.endDate.setErrors(null);
    var one_day = 1000 * 60 * 60 * 24;
    if (!this.startDate.invalid) {
      const fromDate = new Date(this.transform(this.startDate));
      const toDate = new Date(this.transform(this.endDate));

      if (fromDate > toDate) {
        this.isValidStartDate = false;
        this.startDateErrorMessage = this.langData.startDateErrMsg;
        this.startDate.setErrors({ invalidDate: true });
        return;
      }
      // if (Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >= 31) {
      //   this.isValidStartDate = false;
      //   this.startDateErrorMessage = this.langData.startDateLimitErrMsg;
      //   this.startDate.setErrors({ invalidDate: true });
      //   return;
      // }

      this.isValidStartDate = true;
      this.isValidEndDate = true;
      this.processDataAndDrawChart();
      const error = this.startDate.getError('invalidDate');
      if (error) {
        this.startDate.setErrors(null);
      }
    } else {
      this.startDateErrorMessage = this.langData.invalidDate;
    }
  }

  validateEndDate() {
    this.isValidEndDate = true;
    this.isValidStartDate = true;
    this.startDate.setErrors(null);
    var one_day = 1000 * 60 * 60 * 24;
    if (!this.endDate.invalid) {
      const fromDate = new Date(this.transform(this.startDate));
      const toDate = new Date(this.transform(this.endDate));

      if (fromDate > toDate) {
        this.isValidEndDate = false;
        this.endDateErrorMessage = this.langData.startDateErrMsg;
        this.endDate.setErrors({ invalidDate: true });
        return;
      }
      if (Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >= 31) {
        this.isValidEndDate = false;
        this.endDateErrorMessage = this.langData.startDateLimitErrMsg;
        this.endDate.setErrors({ invalidDate: true });
        return;
      }

      this.isValidEndDate = true;
      this.isValidStartDate = true;
      this.processDataAndDrawChart();
      const error = this.endDate.getError('invalidDate');
      if (error) {
        this.endDate.setErrors(null);
      }
    } else {
      this.endDateErrorMessage = this.langData.invalidDate;
    }
  }
  showTrend() {}
}
